var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadRoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_308",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29224",
    "data-name": "Group 29224",
    transform: "translate(286 10575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27963",
    "data-name": "Group 27963",
    transform: "translate(-277 -10569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28370",
    "data-name": "Group 28370",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_308)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308-2",
    "data-name": "Ellipse 308",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_14_",
    "data-name": "svgexport-17 (14)",
    transform: "translate(-265.511 -10809.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50522",
    "data-name": "Path 50522",
    d: "M154.136,263.328a.493.493,0,0,1-.5-.5v-3.068l-1.793-1.295a.472.472,0,0,1-.2-.3.529.529,0,0,1,.08-.378l1.255-1.673a.481.481,0,0,1,.657-.12l2.848,2.072a.49.49,0,0,1,.2.4l.02,4.382a.477.477,0,0,1-.5.478Z",
    transform: "translate(-149.599 0)",
    fill: "#99a4ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50523",
    "data-name": "Path 50523",
    d: "M252.5,559.394a.493.493,0,0,1-.5-.5V558h3.068v.916a.477.477,0,0,1-.5.478Z",
    transform: "translate(-247.96 -296.066)",
    fill: "#8a949b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50524",
    "data-name": "Path 50524",
    d: "M140.5,581.864a.493.493,0,0,1-.5-.5v-1.454A1.909,1.909,0,0,1,141.892,578h4.84a.5.5,0,1,1,0,1l.2,2.729a.952.952,0,0,0-.956.936L141,581.406A.472.472,0,0,1,140.5,581.864Z",
    transform: "translate(-138.191 -315.668)",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50525",
    "data-name": "Path 50525",
    d: "M2.068,305.565H-.5a.506.506,0,0,1-.5-.5v-7.928A1.466,1.466,0,0,1,.554,295.7l7.51.08v-7.251A1.539,1.539,0,0,1,9.617,287H22.186a.5.5,0,0,1,.458.319l3.207,9.024a.572.572,0,0,1-.06.438.448.448,0,0,1-.4.179h-.3l-8.107,7.789a.48.48,0,0,1-.339.8l-5.338.02a.5.5,0,0,1-.5-.478H2.546A.472.472,0,0,1,2.068,305.565Z",
    transform: "translate(0 -30.464)",
    fill: "#ffd300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50526",
    "data-name": "Path 50526",
    d: "M133.119,947.239a5.119,5.119,0,1,1,5.119-5.119A5.143,5.143,0,0,1,133.119,947.239Z",
    transform: "translate(-126.43 -667.516)",
    fill: "#464f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50527",
    "data-name": "Path 50527",
    d: "M503,341.868l15.677.179L515.828,334H503.618a.571.571,0,0,0-.6.578v7.291Z",
    transform: "translate(-493.961 -76.528)",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50528",
    "data-name": "Path 50528",
    d: "M215.446,1027.892a3.446,3.446,0,1,1,3.466-3.446A3.49,3.49,0,0,1,215.446,1027.892Z",
    transform: "translate(-208.757 -749.843)",
    fill: "#6a717c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50529",
    "data-name": "Path 50529",
    d: "M655.59,875.609H653.5a.5.5,0,0,1,0-1h2.092a.493.493,0,0,1,.5.5A.506.506,0,0,1,655.59,875.609Zm0-1.613H653.5a.493.493,0,0,1-.5-.5.506.506,0,0,1,.5-.5h2.092a.5.5,0,0,1,0,1Z",
    transform: "translate(-640.973 -604.791)",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50530",
    "data-name": "Path 50530",
    d: "M540.988,410.8H538.5a.493.493,0,0,1-.5-.5V406.6a.489.489,0,0,1,.5-.478h2.49a.5.5,0,0,1,.5.478v3.745A.549.549,0,0,1,540.988,410.8Zm9.661.1H543.1a.506.506,0,0,1-.5-.5v-3.426a.991.991,0,0,1,.976-.976h5.637a.466.466,0,0,1,.438.339l1.414,3.924a.5.5,0,0,1-.06.438A.379.379,0,0,1,550.649,410.9Z",
    transform: "translate(-528.263 -147.094)",
    fill: "#92ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50531",
    "data-name": "Path 50531",
    d: "M311.494,1122.008a1.479,1.479,0,0,1-1.494-1.494,1.509,1.509,0,0,1,1.494-1.514,1.526,1.526,0,0,1,1.514,1.514A1.509,1.509,0,0,1,311.494,1122.008Z",
    transform: "translate(-304.805 -845.891)",
    fill: "#2e343d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50532",
    "data-name": "Path 50532",
    d: "M1022.464,752.2a7.049,7.049,0,0,1-6.593-4.522.456.456,0,0,1,.279-.618c.02-.02.04-.02.08-.04l.179-3.944a.429.429,0,0,1-.219-.04.485.485,0,0,1-.259-.637,7.1,7.1,0,0,1,13.665,2.689A7.133,7.133,0,0,1,1022.464,752.2Z",
    transform: "translate(-996.573 -472.48)",
    fill: "#464f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50533",
    "data-name": "Path 50533",
    d: "M1109.46,829a5.444,5.444,0,0,1-4.8-2.848.464.464,0,0,1,.2-.657.346.346,0,0,1,.279-.06l-.08-3.964a.337.337,0,0,1-.2-.06.515.515,0,0,1-.179-.677A5.509,5.509,0,1,1,1109.46,829Z",
    transform: "translate(-1083.569 -550.887)",
    fill: "#6a717c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50534",
    "data-name": "Path 50534",
    d: "M868.956,946.956H858.5a.493.493,0,0,1-.5-.5V941.5a.506.506,0,0,1,.5-.5h10.418a2.978,2.978,0,0,1,.04,5.956Z",
    transform: "translate(-841.889 -671.437)",
    fill: "#99a4ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50535",
    "data-name": "Path 50535",
    d: "M1271.574,1018.147a1.59,1.59,0,0,1-1.574-1.574,1.564,1.564,0,0,1,1.574-1.574,1.574,1.574,0,0,1,0,3.147Z",
    transform: "translate(-1245.682 -743.963)",
    fill: "#2e343d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadRoller);
export default __webpack_public_path__ + "static/media/roadRoller.15828d21335ce61ca641a9013aa60803.svg";
export { ForwardRef as ReactComponent };